<template>
  <v-dialog v-model="dialog" persistent max-width="1200px">
    <Create
      :createDialog="categoryCreateDialog"
      @close="categoryCreateDialog = false"
      @submit="getCategory"
    ></Create>
    <DepartmentCreate
      :createDialog="departmentCreateDialog"
      @close="departmentCreateDialog = false"
      @submit="getDepartment"
    ></DepartmentCreate>
    <BrandCreate
      :createDialog="brandCreateDialog"
      @close="brandCreateDialog = false"
      @submit="getBrand"
    ></BrandCreate>
    <v-card grid-list-md>
      <v-toolbar dense class="mb-3" flat color="grey lighten-3">
        <v-toolbar-title class="subtitle-1">New Product</v-toolbar-title>
        <v-spacer> </v-spacer>
        <!-- <v-checkbox
          label="Product Active"
          hide-details
          outlined
          dense
          class="mr-2"
          v-model="Product.active"
        ></v-checkbox> -->
        <v-btn small icon @click.stop.prevent="close()">
          <v-icon small>close</v-icon>
        </v-btn>
      </v-toolbar>
      <!-- <ModelTitle title="Edit Product" @close="close()" /> -->

      <v-container v-if="Product">
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <InnerTitle title="Image, Name & Brand" />
            <v-row>
              <v-col cols="12">
                <ImageView
                  :name="searchName"
                  field="product"
                  :initUrl="Product.imageUrl"
                  @submit="imageChange"
                />
              </v-col>
              <v-col cols="12" md="6" sm="12" v-if="!Product.isParent">
                <v-text-field
                  v-model="Product.upc"
                  @focus="$event.target.select()"
                  outlined
                  @click:append="generateRandomUPC"
                  append-icon="mdi-barcode-scan"
                  hide-details
                  dense
                  label="UPC Code"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" sm="12" v-if="!Product.isParent">
                <v-text-field
                  v-model="Product.sku"
                  @focus="$event.target.select()"
                  outlined
                  @click:append="generateRandomSKU"
                  append-icon="mdi-barcode-scan"
                  hide-details
                  dense
                  label="SKU Code"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="Product.name"
                  :error-messages="nameErrors"
                  :hide-details="nameErrors.length === 0"
                  outlined
                  autofocus
                  @change="changeName"
                  @focus="$event.target.select()"
                  dense
                  label="Name"
                  ref="productName"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-select
                  :items="Category"
                  clearable
                  :hide-details="selectCategoryError.length === 0"
                  :error-messages="selectCategoryError"
                  v-model="Product.CategoryId"
                  item-text="name"
                  outlined
                  dense
                  item-value="id"
                  label="Select Category"
                  ><template v-slot:append-item>
                    <v-divider class="mb-2"></v-divider>
                    <v-list-item @click="categoryCreateDialog = true">
                      <v-list-item-content>
                        <v-list-item-title
                          >Create New Category</v-list-item-title
                        >
                      </v-list-item-content>
                    </v-list-item>
                  </template></v-select
                >
              </v-col>
              <v-col cols="12">
                <v-select
                  :items="Department"
                  clearable
                  hide-details
                  v-model="Product.DepartmentId"
                  item-text="name"
                  outlined
                  dense
                  item-value="id"
                  label="Select Department"
                  ><template v-slot:append-item>
                    <v-divider class="mb-2"></v-divider>
                    <v-list-item @click="departmentCreateDialog = true">
                      <v-list-item-content>
                        <v-list-item-title
                          >Create New Department</v-list-item-title
                        >
                      </v-list-item-content>
                    </v-list-item>
                  </template></v-select
                >
              </v-col>
              <v-col cols="12">
                <v-select
                  :items="Brand"
                  clearable
                  hide-details
                  v-model="Product.BrandId"
                  item-text="name"
                  outlined
                  dense
                  item-value="id"
                  label="Select Brand"
                  ><template v-slot:append-item>
                    <v-divider class="mb-2"></v-divider>
                    <v-list-item @click="brandCreateDialog = true">
                      <v-list-item-content>
                        <v-list-item-title>Create New Brand</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template></v-select
                >
              </v-col>
              <v-col
                cols="12"
                v-if="
                  currentBusiness.metadata &&
                  currentBusiness.metadata.parentChile &&
                  !Product.isParent
                "
              >
                <v-select
                  v-if="Products"
                  :items="Products"
                  clearable
                  v-model="Product.ChildProductId"
                  hide-no-data
                  item-text="name"
                  outlined
                  dense
                  item-value="id"
                  label="Select Parent Product"
                  ><template v-slot:append-item> </template>
                </v-select>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="6" md="4" v-if="!Product.isParent">
            <InnerTitle title="Purchase & Sale" />
            <v-row>
              <v-col cols="6" v-if="!Product.isParent">
                <v-text-field
                  v-model="Product.cost"
                  @focus="$event.target.select()"
                  class="right-input"
                  outlined
                  hide-details
                  dense
                  label="Purchase Cost"
                ></v-text-field>
              </v-col>
              <v-col cols="6" v-if="!Product.isParent">
                <v-text-field
                  v-model="Product.price"
                  class="right-input"
                  label="Price"
                  outlined
                  dense
                  hide-details
                  @focus="$event.target.select()"
                ></v-text-field>
              </v-col>
              <v-col
                cols="6"
                v-if="
                  !Product.isParent &&
                  Product.trackInventory &&
                  !Product.trackSerialNumber
                "
              >
                <v-text-field
                  v-model="Product.initBalance"
                  class="right-input"
                  hide-details
                  :disabled="!checkRightStatus(46)"
                  outlined
                  dense
                  @focus="$event.target.select()"
                  label="Opening Balance"
                ></v-text-field>
              </v-col>

              <v-col
                cols="6"
                v-if="Product.trackInventory && !Product.isParent"
              >
                <v-text-field
                  readonly
                  v-model="Product.balance"
                  class="right-input"
                  hide-details
                  :disabled="!checkRightStatus(46)"
                  outlined
                  dense
                  @focus="$event.target.select()"
                  label="Current Stock"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="Product.trackInventory">
              <v-col cols="12">
                <InnerTitle title="Reorder Point" />
              </v-col>

              <v-col cols="6">
                <v-text-field
                  v-model="Product.min"
                  class="right-input"
                  label="Min"
                  outlined
                  dense
                  hide-details
                  @focus="$event.target.select()"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="Product.max"
                  class="right-input"
                  label="Max"
                  outlined
                  dense
                  hide-details
                  @focus="$event.target.select()"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row
              v-if="
                currentBusiness &&
                currentBusiness.metadata &&
                currentBusiness.metadata.boxCountOnInventory &&
                !Product.isParent
              "
            >
              <v-col cols="12">
                <InnerTitle title="Unit count in the box" />
              </v-col>

              <v-col cols="6">
                <v-text-field
                  type="number"
                  v-model="Product.unitCountInBox"
                  class="right-input"
                  label="Unit Count"
                  outlined
                  dense
                  hide-details
                  @focus="$event.target.select()"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  type="number"
                  readonly
                  v-model="Product.unitPrice"
                  class="right-input"
                  label="Unit Price"
                  outlined
                  dense
                  hide-details
                  @focus="$event.target.select()"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  counter="counter"
                  hide-details
                  outlined
                  dense
                  auto-grow
                  v-model="Product.note"
                  label="Description"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <InnerTitle title="Status, Purchase & Sale" />
            <v-row>
              <v-col cols="12">
                <v-row align="center">
                  <v-col class="py-0">
                    <div class="subtitle-2">Active</div>
                    <div class="caption">
                      Disabling this will make the product inactive. It will
                      still appear in lists but cannot be sold or purchased.
                    </div>
                  </v-col>
                  <v-col class="text-right shrink py-0">
                    <v-switch
                      color="amber lighten-2"
                      v-model="Product.active"
                      inset
                    ></v-switch>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-row align="center">
                  <v-col class="py-0">
                    <div class="subtitle-2">Parent Product</div>
                    <div class="caption">
                      As a parent product, this item won’t be available for
                      sale, but you can add and manage sub-products under it.
                    </div>
                  </v-col>
                  <v-col class="text-right shrink py-0">
                    <v-switch
                      color="amber lighten-2"
                      :disabled="Product.trackSerialNumber"
                      v-model="Product.isParent"
                      inset
                    ></v-switch>
                    <!-- v-if="
                      currentBusiness.metadata &&
                      currentBusiness.metadata.parentChile &&
                      !Product.isParent
                    " -->
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-divider></v-divider>
              </v-col>

              <v-col cols="12">
                <v-row align="center">
                  <v-col class="py-0">
                    <div class="subtitle-2">Inventory</div>
                    <div class="caption">
                      Turn this on to track inventory count.
                    </div>
                  </v-col>
                  <v-col class="text-right shrink py-0">
                    <v-switch
                      v-model="Product.trackInventory"
                      color="amber lighten-2"
                      :disabled="trackInventory"
                      inset
                    ></v-switch>
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                cols="12"
                v-if="
                  this.currentBusiness.metadata &&
                  this.currentBusiness.metadata.serializeProduct
                "
              >
                <v-row align="center">
                  <v-col class="py-0">
                    <div class="subtitle-2">Serial Track</div>
                    <div class="caption">
                      Enable this option to track inventory using serial
                      numbers.
                    </div>
                  </v-col>
                  <v-col class="text-right shrink py-0">
                    <v-switch
                      color="amber lighten-2"
                      v-model="Product.trackSerialNumber"
                      inset
                    ></v-switch>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-row align="center">
                  <v-col class="py-0">
                    <div class="subtitle-2">Remote Order</div>
                    <div class="caption">
                      Enable this to let customers view and order this product
                      online.
                    </div>
                  </v-col>
                  <v-col class="text-right shrink py-0">
                    <v-switch
                      v-model="Product.remoteOrder"
                      color="amber lighten-2"
                      inset
                    ></v-switch>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-row align="center">
                  <v-col class="py-0">
                    <div class="subtitle-2">Special</div>
                    <div class="caption">
                      Mark this product as special on remote ordering.
                    </div>
                  </v-col>
                  <v-col class="text-right shrink py-0">
                    <v-switch
                      v-model="Product.special"
                      color="amber lighten-2"
                      inset
                    ></v-switch>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-row align="center">
                  <v-col class="py-0">
                    <div class="subtitle-2">Weight</div>
                    <div class="caption">
                      Weight will ask on this product sale and multiply with
                      sale price.
                    </div>
                  </v-col>
                  <v-col class="text-right shrink py-0">
                    <v-switch
                      color="amber lighten-2"
                      v-model="Product.metadata.weightApply"
                      inset
                    ></v-switch>
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                cols="12"
                v-if="
                  currentBusiness.metadata &&
                  currentBusiness.metadata.dynamicPrice
                "
              >
                <v-row align="center">
                  <v-col class="py-0">
                    <div class="subtitle-2">Dynamic Price</div>
                    <div class="caption">
                      Dynamic pricing is currently enabled. Turn on this option
                      to exclude this product from dynamic pricing and keep its
                      price fixed, regardless of any pricing rules set in the
                      system.
                    </div>
                  </v-col>
                  <v-col class="text-right shrink py-0">
                    <v-switch
                      color="amber lighten-2"
                      v-model="Product.metadata.standardPrice"
                      inset
                    ></v-switch>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="currentBusiness && currentBusiness.metadata && !currentBusiness.metadata.isSingleCustomerPricing">
                <v-row align="center">
                  <v-col class="py-0">
                    <div class="subtitle-2">Price Tier</div>
                    <div class="caption">
                      Set the prices for different Tiers
                    </div>
                  </v-col>

                  <v-col class="text-right shrink py-0">
                    <ProductPriceTier
                      @save="priceTierSave"
                      :price="Product.price"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
      <!-- <v-card-text v-if="editProduct">
        <AttachmentMiniList :id="editProduct.id" type="PRODUCT" />
      </v-card-text> -->
      <v-divider class="mt-4"></v-divider>
      <v-card-actions>
        <!-- <MoreImage
          ref="addImageUrl"
          :imageResult="imageResult"
          @submit="imageChange"
        /> -->
        <v-spacer></v-spacer>
        <v-btn color="primary" text="text" @click="close()">Close</v-btn>
        <v-btn color="primary" :loading="loading" dark @click="submit()"
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import productService from "../service.js";
import categoryService from "@/modules/Product/Category/service";
import departmentService from "@/modules/Product/Department/service";
import brandService from "@/modules/Product/Brand/service";
import GlobalFunction from "@/mixins/GlobalFunction";
import ImageView from "@/components/Image/ImageView";
import { mapGetters } from "vuex";
import ProductPriceTier from "@/modules/Product/PriceTier/components/InProductPriceTier";
const { validationMixin } = require("vuelidate");
const { required, minLength, minValue } = require("vuelidate/lib/validators");
const Create = () => import("@/modules/Product/Category/components/Create");
const DepartmentCreate = () =>
  import("@/modules/Product/Department/components/Create");
const BrandCreate = () => import("@/modules/Product/Brand/components/Create");

export default {
  props: {
    createDialog: {
      default: false,
    },
  },
  name: "create-product",
  data() {
    return {
      selectedProduct: null,
      productSearchLoading: false,
      Products: [],
      categoryCreateDialog: false,
      departmentCreateDialog: false,
      brandCreateDialog: false,
      Category: [],
      Department: [],
      Brand: [],
      searchName: null,
      imageResult: null,
      selectedCategory: null,
      loading: false,
      dialog: false,
      trackInventory: true,
      Product: {
        initBalance: 0,
        upc: null,
        sku: null,
        isParent: false,
        name: null,
        note: null,
        imageUrl: null,
        price: 0,
        cost: 0,
        boxPrice: null,
        unitCountInBox: null,
        trackSerialNumber: false,
        balance: 0,
        remoteOrder: true,
        special: false,
        trackInventory: true,
        min: null,
        max: null,
        active: true,
        metadata: {
          weightApply: false,
          standardPrice: false,
        },
      },
    };
  },
  mixins: [validationMixin, GlobalFunction],
  validations: {
    Product: {
      name: {
        required,
        minLength: minLength(4),
      },
      CategoryId: {
        required,
        minValue: minValue(1),
      },
    },
  },
  components: {
    // MoreImage,
    ProductPriceTier,
    ImageView,
    Create,
    BrandCreate,
    DepartmentCreate,
  },
  computed: {
    ...mapGetters("global", [
      "comboBox",
      "comboBoxByID",
      "checkRightStatus",
      "currentUser",
      "currentBusiness",
    ]),
    nameErrors() {
      const errors = [];
      if (!this.$v.Product.name.$dirty) return errors;
      if (!this.$v.Product.name.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Product.name.minLength)
        errors.push("Field must be at least 4 characters long");
      return errors;
    },
    selectCategoryError() {
      const errors = [];
      if (!this.$v.Product.CategoryId.$dirty) return errors;
      if (!this.$v.Product.CategoryId.required)
        errors.push(this.$t("validations.fieldIsRequired"));
      if (!this.$v.Product.CategoryId.minValue)
        errors.push("Pleaes select category");

      return errors;
    },
  },
  watch: {
    // 'Product.trackSerialNumber': function (val) {
    //   if (!val) {
    //     this.Product.trackInventory = true
    //   }
    // },
    "Product.isParent": function (val) {
      if (!val) {
        this.selectedProduct = null;
      }
    },
    "Product.unitCountInBox": function () {
      this.updateboxPrice();
    },
    "Product.price": function () {
      this.updateboxPrice();
    },
    Product: {
      handler(val) {
        if (val.trackSerialNumber) {
          this.Product.trackInventory = true;
          this.trackInventory = true;
        } else {
          this.trackInventory = false;
        }
      },
      deep: true,
    },
    // Product: {
    //   handler(val) {
    //     // console.log('val', val)
    //     // if (val.trackInventory) {
    //     //   if (val.price && val.unitCountInBox) {
    //     //     val.boxPrice = val.price * val.unitCountInBox
    //     //   }
    //     //   if (val.boxPrice && val.unitCountInBox) {
    //     //     console.log('in heer', val.boxPrice, val.unitCountInBox, val.price)
    //     //     val.price = val.boxPrice / val.unitCountInBox
    //     //   }
    //     // }

    //     if (val.trackSerialNumber) {
    //       this.Product.trackInventory = true;
    //       this.trackInventory = true;
    //     } else {
    //       this.trackInventory = false;
    //     }
    //   },
    //   deep: true,
    // },
    createDialog(val) {
      this.dialog = val;
      if (val) {
        this.getCategory();
        this.getDepartment();
        this.getBrand();
        this.$nextTick(() => {
          this.$refs.productName.focus();
          // console.log('this.custo', this.currentBusiness.metadata.ForcedInventoryTracking)
          if (this.currentBusiness?.metadata?.ForcedInventoryTracking) {
            this.Product.trackInventory = true;
            this.trackInventory = true;
          }
        });
      }
    },
  },
  methods: {
    priceTierSave(val) {
      // console.log("price tier save", val);
      this.Product.PriceTiers = val;
    },
    generateRandomUPC() {
      let upc = "C"; // Start with 'C'
      for (let i = 1; i < 12; i++) {
        // Start the loop from 1 because 'C' is already added
        upc += Math.floor(Math.random() * 10); // Generate a random digit (0-9)
      }
      this.Product.upc = upc;
    },
    generateRandomSKU() {
      let sku = "K"; // Start with 'C'
      for (let i = 1; i < 12; i++) {
        // Start the loop from 1 because 'C' is already added
        sku += Math.floor(Math.random() * 10); // Generate a random digit (0-9)
      }
      console.log("generated SKU", sku);
      this.Product.sku = sku;
    },
    getProduct() {
      this.loading = true;

      return productService.getAll({ isParent: true }).then((result) => {
        // console.log("get prodcut", result);
        this.Products = result.data;
        this.loading = false;
      });
    },
    updateboxPrice() {
      if (
        this.Product.trackInventory &&
        this.Product.unitCountInBox > 0 &&
        this.Product.price > 0
      ) {
        this.Product.boxPrice = (
          this.Product.price * this.Product.unitCountInBox
        ).toFixed(2);
        this.Product.boxPrice = parseFloat(this.Product.boxPrice);
      }
    },
    imageChange(val) {
      // console.log("image change ", val);
      if (val) {
        this.Product.imageUrl = val;
      }
    },
    changeName() {
      this.Product.name = this.properCase(this.Product.name);
      this.searchName = this.Product.name;
      // this.getimage(this.Product.name).then(response => {
      //   console.log('response', response)
      //   if (response.data) {
      //     this.imageResult = response.data;
      //     this.Product.imageUrl = response.data.imgUrl1;
      //   }
      // });
    },
    getimage(name) {
      return productService
        .getGooglePic({ name: name })
        .then((response) => {
          return response;
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    close() {
      this.empty();
      this.$emit("close");
    },
    getCategory() {
      this.loading = true;
      return categoryService.getAll().then((response) => {
        this.loading = false;
        this.Category = response.data;
        return response;
      });
    },
    getDepartment() {
      this.loading = true;
      return departmentService.getAll().then((response) => {
        this.loading = false;
        this.Department = response.data;
        return response;
      });
    },
    getBrand() {
      this.loading = true;
      return brandService.getAll().then((response) => {
        this.loading = false;
        this.Brand = response.data;
        return response;
      });
    },
    empty() {
      this.Product = {
        initBalance: 0,
        upc: null,
        sku: null,
        isParent: false,
        name: null,
        note: null,
        imageUrl: null,
        price: 0,
        cost: 0,
        boxPrice: null,
        unitCountInBox: null,
        trackSerialNumber: false,
        balance: 0,
        remoteOrder: true,
        special: false,
        trackInventory: true,
        min: null,
        max: null,
        active: true,
        metadata: {
          weightApply: false,
          standardPrice: false,
        },
      };
      // this.Product = {
      //   isParent: false,
      //   name: null,
      //   note: null,
      //   price: null,
      //   cost: 0,
      //   boxPrice: null,
      //   unitCountInBox: null,
      //   min: null,
      //   max: null,
      //   imageUrl: null,
      //   CategoryId: null,
      //   trackSerialNumber: false,
      //   balance: 0,
      //   trackInventory: false,
      //   active: true,
      //   metadata: {
      //     weightApply: false,
      //   },
      this.$v.$reset();
    },
    submit() {
      if (!this.Product.min && this.Product.max) {
        // console.log('in here')
        this.Product.min = parseInt(this.Product.max / 2);
      }

      if (!this.Product.max && this.Product.min) {
        // console.log('in here')
        this.Product.max = parseInt(this.Product.min * 2);
      }

      if (this.Product.max < this.Product.min) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: "Max balance can't more then min balance",
          });
      }

      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: this.$t("toastMessage.text.invalidFields"),
          });
      } else {
        if (this.imageUrl) {
          this.Product.image = {
            imageUrl: this.imageUrl,
            TypeId: 9,
          };
        }
        this.loading = true;
        if (this.Product.isParent) {
          this.Product.trackInventory = false;
          this.Product.trackSerialNumber = false;
          this.Product.ChildProductId = null;
        }

        return productService
          .create(this.Product)
          .then((result) => {
            if (result.status) {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                })
                .fire({
                  icon: "success",
                  title: "Product is created",
                });
              this.empty();
              this.loading = false;
              this.$emit("submit");
            }
          })
          .catch((err) => {
            // console.log("error", err);
            this.loading = false;
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "error",
                title: err.data.message,
              });
          });
      }
    },
  },
};
</script>

<style scoped></style>
